import SimpleSearchSelect from "../../../../Forms/Input/SimpleSearchSelect";

interface Option {
  id: number;
  name: string;
}

interface Props {
  name: string;
  label: string;
  value: string;
  options: Option[];
  onChange: (value: string) => void;
}

const SearchSelectFilterField: React.FC<Props> = ({
  name,
  label,
  value,
  options,
  onChange,
}) => (
  <SimpleSearchSelect
    label={label}
    name={name}
    options={options}
    selectedValue={value ? parseInt(value) : null}
    onSelect={(selected) => onChange(String(selected.id))}
    searchPlaceholder={`Buscar ${label.toLowerCase()}...`}
    iconKey="list"
  />
);

export default SearchSelectFilterField;
